
export default function ChartCard({ title, badge, children }) {
  return (
    <div className="modern-chart-card">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="chart-title mb-0">{title}</h6>
        <span className="chart-badge">{badge}</span>
      </div>

      <div className="chart-wrapper">{children}</div>
    </div>
  );
}